var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSupportServices(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 540.781,
    height: 291.5,
    viewBox: "0 0 540.781 291.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#e6e6e6;}.b{fill:#44bba4;}.c{fill:#3f3d56;}.d{fill:#fff;stroke:#707070;}.e{stroke:none;}.f{fill:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-815 -269)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M649.374,427.69H416.393a14.039,14.039,0,0,1-14.023-14.023V311.544a14.039,14.039,0,0,1,14.023-14.023H649.374A14.04,14.04,0,0,1,663.4,311.544V413.667a14.039,14.039,0,0,1-14.024,14.023Z",
    transform: "translate(676.686 132.81)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 17,
    cy: 17,
    r: 17,
    transform: "translate(815 276)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M160.314,172.19a18,18,0,1,1,18-18A18,18,0,0,1,160.314,172.19Zm0-34a16,16,0,1,0,16,16A16,16,0,0,0,160.314,138.19Z",
    transform: "translate(676.686 132.81)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 17,
    cy: 17,
    r: 17,
    transform: "translate(1022 490)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M367.314,386.19a18,18,0,1,1,18-18,18,18,0,0,1-18,18Zm0-34a16,16,0,1,0,16,16,16,16,0,0,0-16-16Z",
    transform: "translate(676.686 132.81)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 17,
    cy: 17,
    r: 17,
    transform: "translate(1154 361)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M499.314,257.19a18,18,0,1,1,18-18A18,18,0,0,1,499.314,257.19Zm0-34a16,16,0,1,0,16,16A16,16,0,0,0,499.314,223.19Z",
    transform: "translate(676.686 132.81)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M664.571,417.215H431.59a14.541,14.541,0,0,1-14.524-14.524V300.569a14.54,14.54,0,0,1,14.524-14.523H664.571a14.54,14.54,0,0,1,14.524,14.523V402.691a14.54,14.54,0,0,1-14.523,14.524ZM431.59,288.045a12.538,12.538,0,0,0-12.524,12.524V402.691a12.538,12.538,0,0,0,12.524,12.524H664.571a12.538,12.538,0,0,0,12.524-12.524V300.569a12.538,12.538,0,0,0-12.524-12.523Z",
    transform: "translate(676.686 132.81)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "d",
    transform: "translate(1104 450)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "e",
    width: 218,
    height: 20,
    rx: 10
  }), /*#__PURE__*/React.createElement("rect", {
    className: "f",
    x: 0.5,
    y: 0.5,
    width: 217,
    height: 19,
    rx: 9.5
  })), /*#__PURE__*/React.createElement("g", {
    className: "d",
    transform: "translate(1108 483)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "e",
    width: 218,
    height: 20,
    rx: 10
  }), /*#__PURE__*/React.createElement("rect", {
    className: "f",
    x: 0.5,
    y: 0.5,
    width: 217,
    height: 19,
    rx: 9.5
  })), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M423.538,329.335H190.557a14.039,14.039,0,0,1-14.024-14.023V213.189a14.04,14.04,0,0,1,14.024-14.024H423.538a14.04,14.04,0,0,1,14.024,14.024V315.312a14.039,14.039,0,0,1-14.024,14.023Z",
    transform: "translate(676.686 132.81)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "d",
    transform: "translate(875 387)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "e",
    width: 218,
    height: 20,
    rx: 10
  }), /*#__PURE__*/React.createElement("rect", {
    className: "f",
    x: 0.5,
    y: 0.5,
    width: 217,
    height: 19,
    rx: 9.5
  })), /*#__PURE__*/React.createElement("g", {
    className: "d",
    transform: "translate(876 354)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "e",
    width: 218,
    height: 20,
    rx: 10
  }), /*#__PURE__*/React.createElement("rect", {
    className: "f",
    x: 0.5,
    y: 0.5,
    width: 217,
    height: 19,
    rx: 9.5
  })), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M438.734,318.86H205.753a14.54,14.54,0,0,1-14.524-14.523V202.214a14.54,14.54,0,0,1,14.524-14.523H438.734a14.54,14.54,0,0,1,14.524,14.523V304.337a14.54,14.54,0,0,1-14.524,14.523ZM205.753,189.69a12.538,12.538,0,0,0-12.524,12.523V304.337a12.538,12.538,0,0,0,12.524,12.523H438.734a12.538,12.538,0,0,0,12.524-12.523V202.214a12.538,12.538,0,0,0-12.524-12.523Z",
    transform: "translate(676.686 132.81)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupportServices);
export default __webpack_public_path__ + "static/media/support-services.17b85c1cdfb58cd7818910e377b2db21.svg";
export { ForwardRef as ReactComponent };